import { TemplateRef } from '@angular/core';

export class ColumnOptions {
  group?: string;
  groupHeaderClass?: string;
  field: string;
  title: string;
  order: number;
  pipeToken?: any;
  pipeArgs?: any;
  type?: 'date' | 'number' | 'string' | 'boolean' | 'multiselect';
  editable?: boolean;
  width?: number;
  hidden?: boolean;
  filterable?: boolean = false;
  filterTemplate?: TemplateRef<any>;
  filterOptions?: { name: string; value: any }[];
  columnTemplate?: TemplateRef<any>;
  headerTemplate?: TemplateRef<any>;
  groupHeaderTemplate?: TemplateRef<any>;
  filterType?:
    | 'boolean'
    | 'text'
    | 'numeric'
    | 'date'
    | 'custom'
    | 'percentage'
    | 'multiselect';
  filterField?: string;
  fixed?: boolean = false;
  sortable?: boolean = false;
  visibleInQuickView?: boolean = false;
  visibleInDetailsView?: boolean = true;
  align?: 'left' | 'center' | 'right' = 'center';
  headerClass?: string;
  class?: string;
  hideForConcept?: string[];

  constructor(
    field: string,
    title: string,
    order?: number,
    pipeToken?: any,
    pipeArgs?: any,
    type?: 'date' | 'number' | 'string' | 'boolean',
    editable?: boolean,
    width?: number,
    filterable?: boolean,
    filterTemplate?: TemplateRef<any>,
    filterOptions?: { name: string; value: any }[],
    columnTemplate?: TemplateRef<any>,
    groupHeaderTemplate?: TemplateRef<any>,
    headerTemplate?: TemplateRef<any>,
    filterType?: 'boolean' | 'text' | 'numeric' | 'date' | 'custom',
    fixed?: boolean,
    sortable?: boolean,
    visibleInQuickView?: boolean,
    align?: 'left' | 'center' | 'right',
    group?: string,
    hideForConcept?: string[]
  ) {
    this.field = field;
    this.title = title;
    this.order = order || Number.MAX_SAFE_INTEGER;
    this.pipeToken = pipeToken;
    this.pipeArgs = pipeArgs;
    this.type = type;
    this.editable = editable;
    this.width = width;
    this.filterable = filterable;
    this.filterTemplate = filterTemplate;
    this.filterOptions = filterOptions || [
      { name: 'Yes', value: true },
      { name: 'No', value: false },
    ];
    this.columnTemplate = columnTemplate;
    this.groupHeaderTemplate = groupHeaderTemplate;
    this.headerTemplate = headerTemplate;
    this.filterType = filterType;
    this.fixed = fixed;
    this.sortable = sortable;
    this.visibleInQuickView = visibleInQuickView;
    this.align = align || 'center';
    this.group = group;
    this.hideForConcept = hideForConcept;
  }
}
